export const componentMatcher = function (key) {
    var componentName = "unknow-component";
    switch (key) {
        case "banner_slider":
            componentName = "banner-slider"
            break;
        case "category_horizontal_listview":
            componentName = "category-horizontal-list-view"
            break;
        case "grade_horizontal_listview":
            componentName = "grade-horizontal-list-view"
            break;
        case "my_course_vertical_gridview":
            componentName = "my-course-vertical-grid-view"
            break;
        case "course_vertical_gridview":
            componentName = "course-vertical-grid-view"
            break;
        case "teacher_horizontal_listview":
            componentName = "teacher-horizontal-list-view"
            break;
        case "tag_list":
            componentName = "tag-list-view"
            break;
        default:
            break;
    }
    return componentName
}
const plugin = {
    install: function (Vue, options) {

        Vue.filter("componentMatcher", (key) => {
            return componentMatcher(key)
        })
        Vue.prototype.$componentIs = function (key) {
            return componentMatcher(key)
        }
    }
}

export default plugin